import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { initStorage } from './storage';
import { registerBackButton } from './backButton';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow-condensed/500.css';
import '@fontsource/barlow-condensed/600.css';
import '@fontsource/barlow-condensed/700.css';
import './assets/main.css';

await initStorage();

const app = createApp(App);

app.use(createPinia());
app.use(router);
registerBackButton(router);

app.mount('#app');
